module.exports = __webpack_public_path__ + "static/logo-ab15f579dc4f47f5cd3f70ef69d5509f.png";